import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import UserEditForm from '../UserEditForm/UserEditForm.vue'
import { toast, loading } from '@/shared/utils/UIHelper'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement.js'
import incomereport from '@/shared/http/repositories/realestate/incomereport'

export default{
  mixins: [ActionsForm],
  name: 'CustomerTabs',
  props: {
    editUserData: {
      type: Object,
      default: {}
    },
    entreprisesUserArray: {
      type: Array,
      default: {}
    },
    corretor: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HeadDetailsGama,
    UserEditForm
  },
  data () {
    return {
      headTableEnterprise: ['Empreendimento', 'CEP', 'Cidade', 'Endereço', 'Bairro', 'Número', 'Apartamento', 'Torre'],
      headTableIncome: ['Comprovante', 'Data de envio', ''],
      headTableTickets: ['Valor do Boleto', 'Vencimento', 'Status', 'Baixar Boleto'],
      loadIndex: 0,
      enterpriseUnit: null,
      customerInstallments: {
        installmentsPaid: 0,
        installmentsFuture: 0,
        installmentsDue: 0,
        installmentsOverdue: 0
      },
      nameInput: '',
      customerTickets: [],
      customerIncomes: [],
      incomeReport: {
        nomeComprovante: ''
      },
      indexTableIncome: 0,
      file: []
    }
  },
  methods: {
    GetValueFile (e) {
      this.nameInput = e.target.files[0].name
      this.file = e.target.files[0]
    },
    openFilePdf () {
      document.getElementById('impor-pdf').click()
    },
    onDownloadTicket (ticketId) {
      usermanagement.DownloadBoleto(ticketId)
        .then(res => {
          if (res.status === 200) {
            const linkDownload = document.createElement('a')
            linkDownload.href = `data:image/png;base64,${res.data.data}`
            linkDownload.download = 'imagem.png'
            linkDownload.click()
            URL.revokeObjectURL(linkDownload.href)
          }
        })
        .catch(() => {})
    },
    onDownloadIncome (incomeId) {
      incomereport.DownloadComprovante(incomeId)
        .then(res => {
          if (res.status === 200) {
            let dataResponse = res.data.data

            const linkDownload = document.createElement('a')
            linkDownload.href = `data:image/png;base64,${dataResponse.arquivo.arquivo}`
            linkDownload.download = `${dataResponse.arquivo.descricao}.${dataResponse.arquivo.extensao}`
            linkDownload.click()
            URL.revokeObjectURL(linkDownload.href)
          }
        })
    },
    openModal () {
      this.file = []
      this.incomeReport.nomeComprovante = ''
      this.nameInput = ''
      this.$refs['add-income-report'].show()
    },
    closeModal () {
      this.incomeReport.nomeComprovante = ''
      this.file = []
      this.$refs['add-income-report'].hide()
    },
    upload () {
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      if (this.file.length === 0) {
        toast.info('Selecione um arquivo antes de enviar ')
        loading.close()
        return
      }
      let data = new FormData()
      data.append('arquivo', this.file)
      data.append('comprovante', this.incomeReport.nomeComprovante)
      usermanagement.UploadInformeRendimento(this.editUserData.id, data, conf)
        .then(res => {
          if (res.status === 200) {
            this.closeModal()
            toast.success('Comprovante de informe de rendimento enviado com sucesso ')
            loading.close()
            incomereport.GetAll(this.editUserData.id)
              .then(res => {
                if (res.status === 200) {
                  this.customerIncomes = res.data.data
                }
              })
          }
        })
        .catch(() => {})
    },
    onsubmit () {},
    updateView () {
      this.$emit('updateView')
    }
  },
  watch: {
    enterpriseUnit () {
      let data = {
        clienteId: this.editUserData.id,
        empreendimentoUnidadeId: this.enterpriseUnit
      }
      usermanagement.GetBoletosCliente(data)
        .then(res => {
          if (res.status === 200) {
            this.customerTickets = res.data.data
          }
        })

      usermanagement.GetParcelasCliente(data)
        .then(res => {
          if (res.status === 200) {
            this.customerInstallments.installmentsPaid = res.data.data.qtdPaga
            this.customerInstallments.installmentsFuture = res.data.data.qtdFutura
            this.customerInstallments.installmentsDue = res.data.data.qtdAVencer
            this.customerInstallments.installmentsOverdue = res.data.data.qtdVencida
          }
        })
    }
  },
  mounted () {
    // requisition for get the tickes

    let data = {
      clienteId: this.editUserData.id,
      empreendimentoUnidadeId: null
    }
    usermanagement.GetBoletosCliente(data)
      .then(res => {
        if (res.status === 200) {
          this.customerTickets = res.data.data
          if (res.data.data.length === 0) {
            return
          }
          this.enterpriseUnit = this.customerTickets[0].empreendimentoUnidadeId

          let data = {
            clienteId: this.editUserData.id,
            empreendimentoUnidadeId: this.enterpriseUnit
          }
          // requisition for get the installments
          usermanagement.GetParcelasCliente(data)
            .then(res => {
              if (res.status === 200) {
                this.customerInstallments.installmentsPaid = res.data.data.qtdPaga
                this.customerInstallments.installmentsFuture = res.data.data.qtdFutura
                this.customerInstallments.installmentsDue = res.data.data.qtdAVencer
                this.customerInstallments.installmentsOverdue = res.data.data.qtdVencida
              }
            })
        }
      })
    // requisition for get the income report
    incomereport.GetAll(this.editUserData.id)
      .then(res => {
        if (res.status === 200) {
          this.customerIncomes = res.data.data
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/components/CustomerTabs/CustomerTabs.js